/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React from 'react';
import { getCurrentUser, isUserManagerByInitiativeId } from '../../selectors/user';
import { useSelector } from 'react-redux';
import { SurveyAddAssurance } from '../../types/survey';
import { SurveyModelMinData, SurveyModelMinimalUtrv } from '../../model/surveyData';
import { RootState } from '../../reducers';
import { UtrvAssuranceStatus } from '../../types/universalTrackerValue';

interface AssuranceButtonProps {
  survey: SurveyAddAssurance & Pick<SurveyModelMinData, 'roles' | 'initiativeId'>;
  utrv: Pick<SurveyModelMinimalUtrv, '_id'>,
  hasPortfolio: boolean;
  handleAddAssurance: (survey: SurveyAddAssurance) => void;
  isAssuranceStakeholder: boolean;
  getAssuranceStatus: (utrvId: string) => string | false;
}

export const AssuranceButton = (props: AssuranceButtonProps) => {

  const { survey, getAssuranceStatus, utrv, hasPortfolio, handleAddAssurance, isAssuranceStakeholder } = props;

  const isUserManager = useSelector((state: RootState) => isUserManagerByInitiativeId(state, survey?.initiativeId))
  const currentUser = useSelector(getCurrentUser)
  const isSurveyAdmin = currentUser && survey?.roles?.admin?.includes(currentUser._id);

  // Nothing to do, hide it
  if (!hasPortfolio && !isUserManager && !isAssuranceStakeholder && !isSurveyAdmin) {
    return {};
  }

  const id = utrv._id;
  let className = 'add-assurance';
  const assuranceStatus = getAssuranceStatus(id);
  switch (assuranceStatus) {
    case UtrvAssuranceStatus.CompletedOpen:
    case UtrvAssuranceStatus.Completed:
      className = 'assurance-completed';
      break;
    case UtrvAssuranceStatus.Created:
      className = 'assurance-in-progress';
      break;
    default:
      if (!isUserManager && !isAssuranceStakeholder) {
        return {};
      }
  }

  // Status is available or user can add question to assurance
  const tooltip = assuranceStatus ?
    <span>Jump to Assurance Tracker In Progress. </span> :
    <span>Add to Assurance Tracker</span>;

  if (isUserManager) {
    // Manager jumps to assurance portfolio / create portfolio
    return {
      text: hasPortfolio ? tooltip : 'Add Assurance Tracker',
      onClick: () => handleAddAssurance(survey),
      component: <i className={`fa fa-award assurance-btn ${className}`} />
    }
  }

  return {
    text: tooltip,
    onClick: undefined,
    component: <i className={`fa fa-award assurance-btn ${className}`} />,
  }
}
